import Bulldozer5 from "../../assets/png/TU01.png";
import LaunchIcon from "@mui/icons-material/Launch";

const LetsWork = () => {
  return (
    <div>
      <div className="md:pb-[122px] sm:pb-[80px] pb-[50px]">
        <div className="bg-[#fff]">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
            <div className="lg:col-span-4 col-span-1 custom-container sm:pt-[63px] pt-[40px] md:px-[80px] px-[0px] w-[-webkit-fill-available]">
              <div className="md:px-[120px] px-[0px]">
                <div className="flex font-[Roboto] 2xl:text-[36px] 2xl:text-[46px] xl:text-[40px] lg:text-[35px] text-[23px]px] text-[16px] font-bold ">
                  <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
                    LET’S GET TO WO
                    <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
                      RK
                    </span>
                  </span>
                </div>
                <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] lg:mt-[54px] md:mt-[40px] sm:mt-[20px] mt-[10px]">
                  {`At Tuatara, we believe that the future of work is powered by innovation, sustainability, and the
                  people who drive our mission forward. From engineering to sales, every role at Tuatara is critical in
                  building durable, adaptable utility vehicles that meet the needs of industries worldwide. Whether
                  you're passionate about advancing green technologies or supporting our customers in the field, there's
                  a place for you on our team. Join us in shaping the future of off-road utility vehicles and be  part
                  of a company that’s making a difference. There’s work to be done  worldwide—and that work is powered
                  by Tuatara and our people.`}
                </div>

                <button
                  className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] lg:px-[150px] md:px-[100px] sm:px-[50px] px-[30px] mt-[70px] flex items-center"
                  style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                >
                  EXPLORE CAREERS{" "}
                  <LaunchIcon className="lg:!text-[36px] md:!text-[26px] sm:!text-[16px]  !text-[16px] ml-[10px]" />
                </button>
              </div>
            </div>

            <div className="col-span-1 w-[-webkit-fill-available]">
              <img src={Bulldozer5} alt="" className="h-full object-left-top object-cover max-h-[622px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LetsWork;
